import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { AccessButton } from "iuvity-ui-components";

interface TextsAndMessagesProps {
  title: string;
  data: any;
}

export const TextsAndMessages: React.FC<TextsAndMessagesProps> = ({
  title,
  data
}) => {
  const {
    t,
  } = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <div className="texts-messages-container">
      <div className="title">
        {title}
      </div>
      <div className="card-container">
        {data.map((item: any) => (
          <div className="card-content" key={item.id} onClick={() => {
            item?.iconname?.includes('download') && sessionStorage.setItem('DOWNLOAD::TEXTMSG', 'true');
            navigate(item.linkto);
          }}>
            <AccessButton
              icon={item.iconname}
              id={item.id}
              label={item.name}
              iconPosition="top"
            />
          </div>
        ))}
        <div className="card-content-divider"></div>
        <div className="card-content-btn" onClick={() => navigate('/translations')}>
          <AccessButton
            icon="iu iu-icon-right"
            id="translations"
            label={t("Dashboard.textsAndMessagesBtn")}
            iconPosition="top"
          />
          </div>
      </div>
    </div>
  );
};
